export default __webpack_public_path__ + "static/media/close-icon.4d15278c.svg";